export const imageConfig = {
  desktop: {
    width: 360,
    height: 220,
  },
  smallDesktop: {
    width: 365,
    height: 220,
  },
  tablet: {
    width: 344,
    height: 210,
  },
  mobile: {
    width: 150,
    height: 122,
  },
};

export const projectImageConfig = {
  desktop: {
    width: 360,
    height: 220,
  },
  tablet: {
    width: 343,
    height: 210,
  },
  mobile: {
    width: 300,
    height: 184,
  },
};

export const articleBlockImageConfig = {
  desktop: {
    width: 262,
    height: 150,
  },
  tablet: {
    width: 262,
    height: 150,
  },
  mobile: {
    width: 262,
    height: 150,
  },
};

export const projectCardLogoConfig = {
  width: 120,
  height: 80,
};
